import styled from 'styled-components'

export const CancelReservationFormWrapper = styled.div`
  > p:first-child {
    margin-bottom: 1rem;
  }

  .paperWarning {
    width: 100%;
    max-width: 100%;
  }

  .requiredInfoText {
    margin: 2rem 0;
    color: #898989;
  }

  > button {
    width: 100%;
    margin-bottom: 2rem;
  }
`

export const TextBoxWrapper = styled.div`
  margin: 2rem 0;

  & > p:nth-child(2) {
    margin-bottom: 1rem;
    line-height: 16px;
  }
`

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30rem;

  & > div {
    margin-bottom: 5rem;
  }
`

export const CancelReservationSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & > h4 {
    margin: 1rem 0;
  }

  .cancelReservationSuccessPaper {
    margin: 2rem 0;
    width: 100%;
    max-width: 100%;
  }

  & > button {
    width: 100%;
    margin-bottom: 2rem;
  }
`